<template>
  <div class="childbox dn-conten-bg" id="app">
    <div class="box" :id="echartsId" ref="tapp"></div>
  </div>
</template>

<script>
import uuidv1 from "uuid/v1";
export default {
  name: "",
  props: {
    pieData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      bg_color1: "#4da6ff",
      btnNum: "one",
      myChart: null,
      dateType1: "",
      echartsId: uuidv1(),
    };
  },
  watch: {
    pieData: {
      handler(newval, oldval) {
        this.fillPie(newval);
      },
      deep: true,
    },
  },
  mounted() {
    this.fillPie(this.pieData);
  },
  methods: {
    fillPie(data) {
      this.myChart = this.$echarts.init(
        document.getElementById(this.echartsId)
      );
      let option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}<br/> {c} ({d}%)",
          //   formatter: "{a} <br/>{b}<br/> {c} ({d}%)"
        },
        color: ["#d4953e", "#78b1e9", "#6ea562", "#e8855b", "#DC143C"],
        legend: {
          //   orient: "horizontal",
          orient: "vertical", //图例水平展示
          //   y: "bottom",
          bottom: "20",
          right: 0,
          icon: "circle",
          formatter: function(val) {
            return val.split("/").join("\n");
          },
        },
        grid: {
          //   bottom: "50%",
          //   left: "1%",
          //   right: "5%",
          containLabel: true,
        },
        toolbox: {
          show: true,
          right: 20,
          feature: {
            saveAsImage: {},
          },
        },
        series: [
          {
            // name: "当用电",
            type: "pie",
            radius: "66%",
            data: data,
            avoidLabelOverlap: true,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
            label: {
              // formatter: "{b}\n{c}kWh\n({d}%)",
              formatter: function(params) {
                let pieName = params.name.split("/").join(" ");
                let num = params.value;
                let percent = params.percent;
                return percent + "%";
              },
              color: "#666",
              fontWeight: "bolder",
            },
          },
        ],
      };
      this.myChart.setOption(option, true);
      let this_ = this;
      window.addEventListener("resize", function() {
        this_.myChart.resize();
      });
    },
    resizeEcharts() {
      if (
        this.myChart != null &&
        this.myChart != "" &&
        this.myChart != undefined
      ) {
        this.myChart.resize();
      }
    },
    // changeBtn(btnNum){
    //     this.btnNum = btnNum;
    //     if(this.btnNum == "one"){
    //         this.fillPie(this.pie.yester);
    //     }else if(this.btnNum == "two"){
    //         this.fillPie(this.pie.month);
    //     }else{
    //         this.fillPie(this.pie.year);
    //     }
    // }
  },
};
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.flex {
  flex: 1;
  padding: 5px;
}
.childbox {
  width: 100%;
  height: 100%;
  flex: 1;
  border-radius: 6px;
  box-sizing: border-box;
  padding: 0px;
  margin-bottom: 10px;
  border: 1px solid #dedcdc;
  box-sizing: border-box;
}
.title_btn {
  height: 58px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  background: #dbdbdb;
}
.title_btn {
  .titdiv {
    flex: 1;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    border-bottom: 1px solid #dedcdc;
    padding-left: 10px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
}
.engTitle {
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.title_btn button {
  height: 100%;
  text-align: center;
  float: left;
  line-height: 58px;
  padding: 0 10px;
  font-size: 14px;
  background: #dbdbdb;
  color: #000;
  font-weight: bold;
  border: 1px solid #dedcdc;
  box-sizing: border-box;
  cursor: pointer;
  border-radius: 0 !important;
  margin: 0 !important;
  border: none;
  border-bottom: 1px solid #dedcdc;
}
.title_btn .active {
  color: #1d6ce9;
  border-color: #dddddd;
  border-bottom: 6px solid #1d6ce9;
  font-weight: bold;
}
.btn_box {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
}
.btn_box >>> .el-button {
  margin: 0 !important;
  border-radius: 0 !important;
}
</style>
